import { render, staticRenderFns } from "./BuyerBlockedChannels.vue?vue&type=template&id=cc3c23d6&scoped=true"
import script from "./BuyerBlockedChannels.vue?vue&type=script&lang=js"
export * from "./BuyerBlockedChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c23d6",
  null
  
)

export default component.exports